import { render, staticRenderFns } from "./LoginLogoutButton.vue?vue&type=template&id=3ccca116"
import script from "./LoginLogoutButton.vue?vue&type=script&lang=js"
export * from "./LoginLogoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports